import { TourConfig } from './tour.types';

import { AI_REQUESTS_TOUR_CONFIG } from './ai-onboarding';
import {
  HOUSE_CHATS_ONBOARDING_TOUR_CONFIG,
  HOUSE_CHATS_ONBOARDING_TOUR_ID,
} from './house-chats-onboarding';
import { CREATE_NEWS_TOUR_CONFIG } from './news-onboarding';
import { REQUEST_PAGE_TOUR_CONFIG } from './request-page-onboarding';

export const TOUR_REGISTRY = {
  request_page: REQUEST_PAGE_TOUR_CONFIG,
  create_news: CREATE_NEWS_TOUR_CONFIG,
  ai_request: AI_REQUESTS_TOUR_CONFIG,
  [HOUSE_CHATS_ONBOARDING_TOUR_ID]: HOUSE_CHATS_ONBOARDING_TOUR_CONFIG,
} satisfies Record<string, TourConfig>;

export type TourRegistryKey = keyof typeof TOUR_REGISTRY;
